import React from "react"
import { ConfigProvider } from "antd"
import vnVN from "antd/lib/locale/vi_VN"
import "moment/locale/vi"
import "dayjs/locale/vi"
import ReactDOM from "react-dom" // Cập nhật dòng này
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import "src/assets/scss/index.scss"
import "./index.scss"
import StoreProvider from "src/lib/store"
import store from "src/redux/store"
import { ThemeProvider } from "styled-components"
import App from "./App"
import ErrorBoundary from "./components/Boundary"
import reportWebVitals from "./reportWebVitals"
import { theme } from "./theme"
import { AnchorProvider } from "react-anchor-navigation"
import {isMobileConst} from "./lib/utils";
import { initZenifyApp } from './initZenify';

// const root = ReactDOM.createRoot(document.getElementById("root"));

if ("serviceWorker" in navigator && isMobileConst) {
    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js")
            .then((reg) => console.log("Service Worker registered!", reg))
            .catch((err) => console.log("Service Worker registration failed!", err));
    });
}

initZenifyApp();

// Bỏ qua lỗi cảnh báo vô hại ResizeObserver của trình duyệt khi tính toán layout bảng/input
window.addEventListener("error", (e) => {
  if (
    e?.message?.includes("ResizeObserver loop") ||
    e?.message?.includes("undelivered notifications")
  ) {
    const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
    const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
    if (resizeObserverErr) resizeObserverErr.style.display = "none";
    if (resizeObserverErrDiv) resizeObserverErrDiv.style.display = "none";
    e.stopImmediatePropagation();
  }
});

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider
      theme={{
        ...theme,
      }}
    >
      <ConfigProvider locale={vnVN}>
        <Provider store={store}>
          <StoreProvider>
            <ErrorBoundary>
              <AnchorProvider>
                <App />
              </AnchorProvider>
            </ErrorBoundary>
          </StoreProvider>
        </Provider>
      </ConfigProvider>
    </ThemeProvider>
  </BrowserRouter>,
  // </React.StrictMode>,
  document.getElementById("root"),
)

reportWebVitals()

